import i18n from "@/i18n/i18n";

export function getAll() {
  return [
    {
      value: 0,
      name: "NormalCost",
      text: `${i18n.global.t("enums.costType.NormalCost")}`,
    },
    {
      value: 1,
      name: "AvgCost",
      text: `${i18n.global.t("enums.costType.AvgCost")}`,
    },
    {
      value: 2,
      name: "LastCost",
      text: `${i18n.global.t("enums.costType.LastCost")}`,
    },
  ];
}
